import styled from 'styled-components';
import { ColorClubMatasPlus3 } from 'autogen/design-tokens/tokens';
import type { BasketMessageMatasPlusViewModel } from 'autogen/swagger/all';
import { Typography } from 'components/generic/typography';
import WithIcon from 'components/hoc/withIcon/WithIcon';
import Icon from 'components/Icon';
import format from 'helpers/translations';
import BasketMessageContainer from '../shared/styles';

const StyledBasketMessageContainer = styled(BasketMessageContainer)`
    background-color: ${ColorClubMatasPlus3};
`;

export default function MatasPlusMessage({ model: { text } }: { model: BasketMessageMatasPlusViewModel }) {
    return (
        <StyledBasketMessageContainer>
            <WithIcon icon={<Icon type="Checkmark" size={16} />}>
                <Typography.Body as="span" size="S">
                    {format(text)}
                </Typography.Body>
            </WithIcon>
        </StyledBasketMessageContainer>
    );
}
